export default __webpack_public_path__ + "static/media/WOR-interview3.1301cc4a.png";